export const IconNotification = ({ className }: { className?: string }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" className={className}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.00004 14.6668C11.6819 14.6668 14.6667 11.6821 14.6667 8.00016C14.6667 4.31826 11.6819 1.3335 8.00004 1.3335C4.31814 1.3335 1.33337 4.31826 1.33337 8.00016C1.33337 11.6821 4.31814 14.6668 8.00004 14.6668ZM8.66671 5.31006C8.66671 5.67825 8.36823 5.97673 8.00004 5.97673C7.63185 5.97673 7.33337 5.67825 7.33337 5.31006C7.33337 4.94187 7.63185 4.64339 8.00004 4.64339C8.36823 4.64339 8.66671 4.94187 8.66671 5.31006ZM8.00004 6.66683C8.36823 6.66683 8.66671 6.96531 8.66671 7.3335V10.6603C8.66671 11.0285 8.36823 11.327 8.00004 11.327C7.63185 11.327 7.33337 11.0285 7.33337 10.6603V7.3335C7.33337 6.96531 7.63185 6.66683 8.00004 6.66683Z"
            />
        </svg>
    );
};
